'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMediaQuery, useTheme } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useAppData, useAppDataDispatch } from '../store/AppDataContext';
export default function useSetScreenSize() {
  var _theme$breakpoints, _theme$breakpoints2, _theme$breakpoints3, _theme$breakpoints4, _theme$breakpoints5, _theme$breakpoints6, _theme$breakpoints7, _theme$breakpoints8, _theme$breakpoints9, _theme$breakpoints0, _theme$breakpoints1, _theme$breakpoints10;
  var dispatch = useAppDataDispatch();
  var theme = useTheme();
  var _useMediaQuery = useMediaQuery(["(max-width: calc(".concat(theme === null || theme === void 0 || (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.mobile, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.mobile, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints3 = theme.breakpoints) === null || _theme$breakpoints3 === void 0 ? void 0 : _theme$breakpoints3.xs, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints4 = theme.breakpoints) === null || _theme$breakpoints4 === void 0 ? void 0 : _theme$breakpoints4.xs, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints5 = theme.breakpoints) === null || _theme$breakpoints5 === void 0 ? void 0 : _theme$breakpoints5.sm, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints6 = theme.breakpoints) === null || _theme$breakpoints6 === void 0 ? void 0 : _theme$breakpoints6.sm, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints7 = theme.breakpoints) === null || _theme$breakpoints7 === void 0 ? void 0 : _theme$breakpoints7.md, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints8 = theme.breakpoints) === null || _theme$breakpoints8 === void 0 ? void 0 : _theme$breakpoints8.md, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints9 = theme.breakpoints) === null || _theme$breakpoints9 === void 0 ? void 0 : _theme$breakpoints9.lg, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints0 = theme.breakpoints) === null || _theme$breakpoints0 === void 0 ? void 0 : _theme$breakpoints0.lg, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints1 = theme.breakpoints) === null || _theme$breakpoints1 === void 0 ? void 0 : _theme$breakpoints1.xl, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints10 = theme.breakpoints) === null || _theme$breakpoints10 === void 0 ? void 0 : _theme$breakpoints10.xl, ")")]),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 7),
    base = _useMediaQuery2[0],
    mobile = _useMediaQuery2[1],
    xs = _useMediaQuery2[2],
    sm = _useMediaQuery2[3],
    md = _useMediaQuery2[4],
    lg = _useMediaQuery2[5],
    xl = _useMediaQuery2[6];
  useEffect(() => {
    switch (true) {
      case base:
        dispatch({
          type: 'ui/screenSize',
          payload: 'base'
        });
        break;
      case mobile:
        dispatch({
          type: 'ui/screenSize',
          payload: 'mobile'
        });
        break;
      case xs:
        dispatch({
          type: 'ui/screenSize',
          payload: 'xs'
        });
        break;
      case sm:
        dispatch({
          type: 'ui/screenSize',
          payload: 'sm'
        });
        break;
      case md:
        dispatch({
          type: 'ui/screenSize',
          payload: 'md'
        });
        break;
      case lg:
        dispatch({
          type: 'ui/screenSize',
          payload: 'lg'
        });
        break;
      case xl:
        dispatch({
          type: 'ui/screenSize',
          payload: 'xl'
        });
        break;
    }
  }, [base, mobile, xs, sm, md, lg, xl, dispatch]);
}
export function useScreenSize() {
  var sizes = {
    isLessThanMobile: undefined,
    isLessThanXs: undefined,
    isLessThanSm: undefined,
    isLessThanMd: undefined,
    isLessThanLg: undefined,
    isLessThanXl: undefined
  };
  var appData = useAppData();
  switch (appData === null || appData === void 0 ? void 0 : appData.screenSize) {
    case 'base':
      return {
        isLessThanMobile: true,
        isLessThanXs: true,
        isLessThanSm: true,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'mobile':
      return {
        isLessThanMobile: false,
        isLessThanXs: true,
        isLessThanSm: true,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'xs':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: true,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'sm':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'md':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: false,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'lg':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: false,
        isLessThanLg: false,
        isLessThanXl: true
      };
    case 'xl':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: false,
        isLessThanLg: false,
        isLessThanXl: false
      };
    default:
      return sizes;
  }
}